// extracted by mini-css-extract-plugin
export default {"tab":"_WluD","tabActive":"VTuc_","text":"wxfvI"};